import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NewFeatureDotService } from 'src/app/services/new-feature-dot.service';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-new-feature-dot',
    templateUrl: './new-feature-dot.component.html',
    styleUrls: ['./new-feature-dot.component.scss'],
    standalone: true,
    imports: [NgIf],
})
export class NewFeatureDotComponent implements OnInit, OnDestroy {
  @Input() featureName: string;
  @Input() featureNames: string[];
  @Input() position = 'top-right';
  showDot: boolean;
  private updateSub: Subscription;

  constructor(private newFeatureDotService: NewFeatureDotService) {}

  ngOnInit() {
    this.updateSub = this.newFeatureDotService.onUpdates.subscribe(event => {
      if (!event) return;
      if (this.featureName) {
        this.showDot = event[1];
      } else {
        if (this.featureNames.length) {
          this.showDot = this.featureNames.every(feature => this.newFeatureDotService.showFeatureAsNew(feature));
        } else {
          this.showDot = false;
        }
      }
    });
    if (this.featureName) {
      this.showDot = this.newFeatureDotService.showFeatureAsNew(this.featureName);
    } else {
      if (this.featureNames.length) {
        this.showDot = this.featureNames.every(feature => this.newFeatureDotService.showFeatureAsNew(feature));
      } else {
        this.showDot = false;
      }
    }
  }

  ngOnDestroy(): void {
    this.updateSub?.unsubscribe();
  }
}
